import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import Json from './Json' //测试用数据
//引入js
import utl from './utils/utils.js';
Vue.prototype.utl = utl;
//引入css
import "./assets/css/public.css"
import "./assets/css/element-index.css"
//模拟异步请求数据
const json = type => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(Json[type]);
    }, 100)
  })
}
Vue.config.productionTip = false
Vue.use(ElementUI, {
    size: 'small'
});
//钩子函数
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})
Vue.prototype.$api = {
  json
};
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js